import Vue from 'vue'
import Vuex from 'vuex'
// import actions from './actions'
// import getters from './getters'
// import mutations from './mutations'
// import state from './state'
import typhoontw from './modules/typhoon_tw'

Vue.use(Vuex)

export const store = new Vuex.Store({
//   state,
//   getters,
//   mutations,
//   actions,
  modules: {
    typhoontw
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js